export default __webpack_public_path__ + "static/2-3e77c9a1a48123dd54df53850370774c.jpeg";